function signedAmount(amount, quantity) {
  const value = Number(amount) || 0;
  const qty = Number(quantity) || 0;
  if (qty < 0 && value > 0) return -value;
  if (qty > 0 && value < 0) return Math.abs(value);
  return value;
}

export function signedProductTotal(product) {
  const stored = Number(product?.totalPrice);
  if (Number.isFinite(stored) && stored !== 0) {
    return signedAmount(stored, product?.quantity);
  }

  const unit = Number(product?.sale_price) > 0
    ? Number(product.sale_price)
    : Number(product?.regular_price) || 0;
  const qty = Number(product?.quantity) || 0;
  return unit * qty;
}
